export const APP_DOMAIN =
  process.env.REACT_APP_DOMAIN || 'localhost'

export const API_URL =
  process.env.REACT_APP_API_URL || '/api'

export const IS_HTTPS =
  process.env.HTTPS === 'true'